import React from 'react';
import { useAppSelector } from 'store/hooks';
import { SourceDetails } from 'features/layout/types';
import { selectUserById } from 'features/users/usersSlice';
import { useLocalMute } from 'features/local-mute/useLocalMute';

export type ClickCallback = (
  e: React.MouseEvent<HTMLButtonElement | HTMLLIElement, MouseEvent>
) => void;

export const useTileLocalMute = (source: SourceDetails) => {
  const user = useAppSelector((state) => selectUserById(state, source.userId));
  const localMute = useLocalMute(user);
  const isRemoteTile = source.kind === 'remote';

  return {
    ...localMute,
    available: isRemoteTile && localMute.available,
    canIsolate: isRemoteTile && localMute.canIsolate,
  };
};
